import { useMemo } from 'react'

import { Schema, useFieldSchema } from '@formily/react'

import { toArray } from '@eastcoal/common/utils/array'

import { FormItem } from '../../FormItem'

const isFormItemDecorator = (item: Schema) => {
  return item['x-decorator'] === FormItem
}

/**
 * 设置 FormItem 的 feedbackLayout 为 popover 以重置下边距
 */
export const useEditableTableSchema = () => {
  const schema = useFieldSchema()

  // 不要使用 useEffect，慢了一拍
  return useMemo(() => {
    toArray(schema?.items).forEach(item => {
      if (isFormItemDecorator(item)) {
        item['x-decorator-props'] = {
          showLabel: false,
          feedbackLayout: 'popover',
          ...item['x-decorator-props']
        }
      }
    })
    return schema
  }, [schema])
}
